export const getCourseStatus = (status) => {
  if (status) {
    return 'Active';
  }
  return 'Inactive';
};
export const formatCategoriesArray = (categoriesArray) => {
  return Object.assign(
    ...categoriesArray.map((entry) => ({
      [entry.category]: entry.subCategories ?? []
    }))
  );
};

export const getFormattedCategories = (categories) => {
  const categoryKeys = Object.keys(categories);
  return categoryKeys.map((categoryKey) => {
    return {
      category: categoryKey,
      subCategories: categories[categoryKey] ?? []
    };
  });
};
export const getCoursePriceCurrency = (currency) => {
  switch (currency) {
    case '$':
      return 'USD';
    default:
      return 'USD';
  }
};

export const formatCalData = (resData) => {
  const { paginatedList } = resData;
  let formattedCalData = {};

  paginatedList.forEach((course) => {
    const { startDate } = course;
    const localStartDate = new Date(startDate);
    const year = localStartDate.getFullYear();
    const month = localStartDate.getMonth();

    const day = localStartDate.getDate();

    if (!formattedCalData[year]) {
      formattedCalData[year] = {};
    }

    if (!formattedCalData[year][month]) {
      formattedCalData[year][month] = {};
    }

    if (!formattedCalData[year][month][day]) {
      formattedCalData[year][month][day] = [];
    }

    formattedCalData[year][month][day].push(course);
  });

  return formattedCalData;
};

export const formatUnitCalData = (resData) => {
  const { paginatedList } = resData;
  let formattedCalData = {};

  paginatedList.forEach((unitOffer) => {
    const { startDate } = unitOffer;
    const localStartDate = new Date(startDate);
    const year = localStartDate.getFullYear();
    const month = localStartDate.getMonth();

    const day = localStartDate.getDate();

    if (!formattedCalData[year]) {
      formattedCalData[year] = {};
    }

    if (!formattedCalData[year][month]) {
      formattedCalData[year][month] = {};
    }

    if (!formattedCalData[year][month][day]) {
      formattedCalData[year][month][day] = [];
    }

    // Filter out unit offer with same course offer code
    if (
      !formattedCalData[year][month][day].find(
        (offer) => offer?.courseOffer?.code === unitOffer?.courseOffer.code
      )
    ) {
      formattedCalData[year][month][day].push(unitOffer);
    }
  });

  return formattedCalData;
};
